import { useResizeObserver } from 'lib/use-resize-observer'
import React, { useCallback, useState } from 'react'

export const useElementSize = (ref: React.RefObject<HTMLElement>) => {
  const [size, setSize] = useState<(null | number)[]>([null, null])

  const callback = useCallback((entry: ResizeObserverEntry) => {
    setSize([entry.contentRect.width, entry.contentRect.height])
  }, [])

  useResizeObserver(ref, callback)

  return size
}

export const useElementWidth = (ref: React.RefObject<HTMLElement>) => useElementSize(ref)[0]

export const useElementHeight = (ref: React.RefObject<HTMLElement>) => useElementSize(ref)[1]
